export default __webpack_public_path__ + "static/media/twitter.68ed5883.svg";